
<template>
  <div>
    <router-view></router-view>
  </div>
</template>


<script lang="ts">
</script>


<style text="text/scss" scoped>

</style>
